export default "__VITE_ASSET__CENL0cRi__"